import axios from 'axios';
import i18n from './../translations/i18n';
import { setCachedPopularCategories } from "./popular-categories";

const API_ENDPOINT_URL       = '/module/brekz_popular_items/fetch_popular';
const CACHE_LOCALSTORAGE_KEY = 'popular-products-cached';
const CACHE_TIME_TO_LIVE     = 1000 * 60 * 60 * 24;

function getCachedPopularProducts() {
    const cachedPopularProductsJson = localStorage.getItem(CACHE_LOCALSTORAGE_KEY);

    if (! cachedPopularProductsJson) {
        // The cache is unavailable, return a cache miss

        return null;
    }

    const cachedPopularProducts = JSON.parse(cachedPopularProductsJson);
    const currentTimestamp      = new Date().getTime();

    if (cachedPopularProducts.timestamp + CACHE_TIME_TO_LIVE < currentTimestamp) {
        // The cache is outdated, return a cache miss

        return null;
    }

    return cachedPopularProducts.products;
}

export function setCachedPopularProducts(products) {
    const cacheData = {
        timestamp: new Date().getTime(),
        products: products
    };

    try {
        localStorage.setItem(CACHE_LOCALSTORAGE_KEY, JSON.stringify(cacheData));
    } catch(e) {
        console.log(e);
    }
}

function getEndpointUrl(){
    if (window.id_shop) {
        switch(window.id_shop) {
            case 8:
                return `/de${API_ENDPOINT_URL}`;
            case 9:
                return `/fr${API_ENDPOINT_URL}`;
            default:
                return API_ENDPOINT_URL;
        }
    }

    return API_ENDPOINT_URL;
}

function getPopularProducts() {
    return new Promise(async (resolve) => {
        try {
            const cachedPopularProducts = getCachedPopularProducts();

            if (cachedPopularProducts && cachedPopularProducts.length) {
                resolve(cachedPopularProducts);

                return;
            }

            const popularProductsResponse = await axios.get(getEndpointUrl());

            if (! popularProductsResponse.data.products) {
                resolve([]);

                return;
            }

            setCachedPopularProducts(popularProductsResponse.data.products);
            setCachedPopularCategories(popularProductsResponse.data.categories);
            resolve(popularProductsResponse.data.products);
        } catch(e) {
            // Return empty results to prevent breaking the search entirely

            resolve([]);
        }
    });
}

export function createPopularProductsPlugin(options) {
    return {
        getSources({ query }) {
            return [
                {
                    sourceId: 'popularProductsPlugin',
                    getItems() {
                        return getPopularProducts();
                    },
                    templates: {
                        header({ items }) {
                            if (! items.length) {
                                return null;
                            }

                            // todo: Improve styling to be more accurate to the Figma design
                            return (
                                <section className="search-bar-popular">
                                    <p className="search-bar-popular__title">{i18n.global.t("algoliaSearch.popularProductsTitle")}:</p>
                                </section>
                            );
                        },
                        item({ item }) {
                            // todo: Improve styling to be more accurate to the Figma design

                            return (
                                <a href={item.product_url} className="search-bar-popular__item">
                                    <section className="search-bar-popular__item-image-wrapper">
                                        <img src={item.image_url} alt={item.name} className="search-bar-popular__item-image" />
                                    </section>

                                    <section className="search-bar-popular__item-title-and-stars">
                                        <h2 className="search-bar-popular__title">{item.name}</h2>

                                        <div className={"search-bar-popular__stars trustpilot-star-rating trustpilot-count-" + item.review_score}>
                                            <div className="trustpilot-star-1"><img alt="1" title="1" src="//images-static.trustpilot.com/community/shared/sprite_star.png" className="trustpilot-star-image"/></div>
                                            <div className="trustpilot-star-2"><img alt="2" title="2" src="//images-static.trustpilot.com/community/shared/sprite_star.png" className="trustpilot-star-image"/></div>
                                            <div className="trustpilot-star-3"><img alt="3" title="3" src="//images-static.trustpilot.com/community/shared/sprite_star.png" className="trustpilot-star-image"/></div>
                                            <div className="trustpilot-star-4"><img alt="4" title="4" src="//images-static.trustpilot.com/community/shared/sprite_star.png" className="trustpilot-star-image"/></div>
                                            <div className="trustpilot-star-5"><img alt="5" title="5" src="//images-static.trustpilot.com/community/shared/sprite_star.png" className="trustpilot-star-image"/></div>

                                            <span className="search-bar-popular__item-review-count">({item.review_count})</span>
                                        </div>
                                    </section>
                                </a>
                            );
                        },
                        noResults() {
                            return null;
                        },
                    },
                },
            ];
        },
    };
}
